/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_SubInputs */

const en_simple_oto_sub = /** @type {(inputs: Simple_Oto_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For business owners, creators and teachers who need a working app — not a course on making one.`)
};

const id_simple_oto_sub = /** @type {(inputs: Simple_Oto_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pemilik usaha, kreator, dan pengajar yang butuh aplikasi kerja — bukan pelajaran membuat aplikasi.`)
};

/**
* | output |
* | --- |
* | "For business owners, creators and teachers who need a working app — not a course on making one." |
*
* @param {Simple_Oto_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_sub = /** @type {((inputs?: Simple_Oto_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_sub(inputs)
	return en_simple_oto_sub(inputs)
});